import sox from './sox';
import BrevSox from './BrevSox';

export default function () {
    sox();
    BrevSox();
}